import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import Spinner from "../comman/Spinner";
import { signupUser, clearErrors, clearMessage } from "../../redux/authSlice";
import ErrorAlert from "../comman/ErrorAlert";
import SuccessAlert from "../comman/SuccessAlert";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../../CoreFile/Header";
import Footer from "../../CoreFile/Footer";
import PhoneInput from "react-phone-input-2";
import { motion } from 'framer-motion';
import "react-phone-input-2/lib/style.css";
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export default function Registration() {
  const [referralCode, setReferralCode] = useState(null);
  const query = useQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, message, auth } = useSelector((state) => state.auth);

  useEffect(() => {
    const referral = query.get("referral");
    if (referral) {
      setReferralCode(referral);
    }
    if (auth) {
      navigate(`/${auth?.role}/dashboard`);
    }
  }, [query, auth]);

  const [showPass, setShowPass] = useState(false);

  const initialValues = {
    fullname: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    referralBy: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Incorrect email").required("Email is required"),
    fullname: Yup.string().required("fullname is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
    phone: Yup.number().required("Phone is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (referralCode) {
        values.referralBy = referralCode;
      }
      dispatch(signupUser(values));
    },
  });

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        dispatch(clearErrors());
      }, 10000);
      return () => clearTimeout(timer);
    }
    if (message) {
      const timer = setTimeout(() => {
        dispatch(clearMessage());
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [error, dispatch, message]);

  return (
    <>
      <Header />
               <div
          className="min-h-screen w-full pt-16 bg-cover bg-center flex items-center justify-center px-4"
          style={{
            backgroundImage:
              "url('https://img.freepik.com/premium-photo/red-blue-background-with-red-line_564714-40769.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid&w=740')",
          }}
        >
          <div className="lg:grid grid-cols-2 gap-4">
          <motion.div
          className="flex-1 hidden lg:flex justify-center items-center"
          animate={{ y: [0, -15, 0] }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        >
          <div className=" rounded-2xl p-3  w-auto h-[200px] flex items-center justify-center transform rotate-6">
            <img src="/BOT3.png" alt="" className="w-auto h-[600px]"/>
          </div>
        </motion.div>
            <div>
            <div className="flex inset-0 w-full items-center justify-center  ">
   
          <div className="w-full max-w-5xl my-12 mx-auto bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl shadow-2xl p-10 text-white">
            <div className="flex justify-between md:flex-row flex-col items-center mb-10">
              <h2 className="md:text-4xl text-3xl   font-extrabold tracking-tight">
                Create Account
              </h2>
              <Link
                to="/user/login"
                className="text-sm px-5 py-1.5 bg-white/20 rounded-full hover:bg-white/30 transition duration-300"
              >
                Sign In
              </Link>
            </div>

            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Full Name */}
                <div className="group">
                  <label htmlFor="fullname" className="text-sm mb-2 block">
                    Full Name
                  </label>
                  <input
                    id="fullname"
                    name="fullname"
                    type="text"
                    required
                    placeholder=""
                    value={formik.values.fullname}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="w-full bg-white/20 border border-transparent hover:border-white/40 focus:border-purple-400 placeholder-white text-white px-4 py-3 rounded-xl focus:outline-none transition duration-300"
                  />
                  {formik.touched.fullname && formik.errors.fullname && (
                    <p className="text-xs text-red-300 mt-1">
                      {formik.errors.fullname}
                    </p>
                  )}
                </div>

                {/* Email */}
                <div className="group">
                  <label htmlFor="email" className="text-sm mb-2 block">
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    placeholder=""
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="w-full bg-white/20 border border-transparent hover:border-white/40 focus:border-purple-400 placeholder-white text-white px-4 py-3 rounded-xl focus:outline-none transition duration-300"
                  />
                  {formik.touched.email && formik.errors.email && (
                    <p className="text-xs text-red-300 mt-1">
                      {formik.errors.email}
                    </p>
                  )}
                </div>

                {/* Password */}
                <div className="group relative">
                  <label htmlFor="password" className="text-sm mb-2 block">
                    Password
                  </label>
                  <input
                    id="password"
                    name="password"
                    type={showPass ? "text" : "password"}
                    required
                    placeholder=""
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="w-full bg-white/20 border border-transparent hover:border-white/40 focus:border-purple-400 placeholder-white text-white px-4 py-3 rounded-xl focus:outline-none transition duration-300"
                  />
                  <span
                    onClick={() => setShowPass(!showPass)}
                    className="absolute top-10 right-4 text-white text-lg cursor-pointer"
                  >
                    {showPass ? <FaRegEyeSlash /> : <FaRegEye />}
                  </span>
                  {formik.touched.password && formik.errors.password && (
                    <p className="text-xs text-red-300 mt-1">
                      {formik.errors.password}
                    </p>
                  )}
                </div>

                {/* Confirm Password */}
                <div className="group">
                  <label
                    htmlFor="confirmPassword"
                    className="text-sm mb-2 block"
                  >
                    Confirm Password
                  </label>
                  <input
                    id="confirmPassword"
                    name="confirmPassword"
                    type={showPass ? "text" : "password"}
                    required
                    placeholder=""
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="w-full bg-white/20  border border-transparent hover:border-white/40 focus:border-purple-400 placeholder-white text-white px-4 py-3 rounded-xl focus:outline-none transition duration-300"
                  />
                  {formik.touched.confirmPassword &&
                    formik.errors.confirmPassword && (
                      <p className="text-xs text-red-300 mt-1">
                        {formik.errors.confirmPassword}
                      </p>
                    )}
                </div>

                {/* Phone */}
                {/* <div className="md:col-span-2">
                  <label htmlFor="phone" className="text-sm mb-2 block">
                    Phone
                  </label>
                  <PhoneInput
                    country={"in"}
                    inputProps={{
                      id: "phone",
                      name: "phone",
                      required: true,
                    }}
                    value={formik.values.phone}
                    onChange={(phone) => formik.setFieldValue("phone", phone)}
                    onBlur={formik.handleBlur}
                    containerClass="w-full"
                    inputClass="w-full py-3 text-sm text-white bg-white/20 border border-transparent hover:border-white/40 px-4 rounded-xl focus:outline-none transition"
                    buttonClass="border border-white/30"
                    dropdownClass="text-black"
                  />
                  {formik.touched.phone && formik.errors.phone && (
                    <p className="text-xs text-red-300 mt-1">
                      {formik.errors.phone}
                    </p>
                  )}
                </div> */}
                <div className="">
                  <label
                    htmlFor="phone"
                    className="text-sm font-medium text-white mb-2 block"
                  >
                    Phone
                  </label>
                  
                  <div className="relative ">
                    <PhoneInput
                      country={"us"}
                      inputProps={{
                        id: "phone",
                        name: "phone",
                        required: true,
                      }}
                      value={formik.values.phone}
                      onChange={(phone) => formik.setFieldValue("phone", phone)}
                      onBlur={formik.handleBlur}
                      containerClass="  !w-full !rounded-xl !text-white"
                      inputClass="!w-full !py-5 !bg-white/20 !text-lg !text-white !pl-12 !border !border-transparent hover:!border-white/40 focus:!border-purple-400 !placeholder-white !px-8  !rounded-xl focus:!outline-none !transition !duration-300"
                      buttonClass="!bg-white/20 !rounded-xl  !border !border-transparent hover:!border-white/40 focus:!border-purple-400 "
                      dropdownClass="!text-black"
                    />
                  </div>
                  {formik.touched.phone && formik.errors.phone && (
                    <p className="text-xs text-red-400 mt-1">
                      {formik.errors.phone}
                    </p>
                  )}
                </div>

                {/* Referral */}
                <div className="">
                  <label htmlFor="referralBy" className="text-sm mb-2 block">
                    Referral Code
                  </label>
                  <input
                    id="referralBy"
                    name="referralBy"
                    type="text"
                    required
                    placeholder="Enter Referral Code"
                    value={referralCode || formik.values.referralBy}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!!referralCode}
                    className="w-full bg-white/20 border border-transparent hover:border-white/40 focus:border-purple-400 placeholder-white text-white px-4 py-3 rounded-xl focus:outline-none transition duration-300"
                  />
                </div>
              </div>

              {/* Terms */}
              <div className="mt-6 flex items-center text-sm">
                <input type="checkbox" id="terms" className="mr-2 h-4 w-4" />
                <label htmlFor="terms" className="text-white/80">
                  I agree to the{" "}
                  <span className="underline text-blue-300">Terms</span>
                </label>
              </div>

              {/* Submit */}
              <div className="mt-6 text-right">
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-gradient-to-r from-[#263283] to-[#ed2924] hover:from-[#1e2558] hover:to-[#872826] px-8 py-3 rounded-full text-sm font-semibold shadow-lg transition-all duration-300"
                >
                  {loading ? <Spinner /> : "Sign Up"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
            </div>
          </div>
      <Footer />
      {error && <ErrorAlert error={error} />}
      {message && <SuccessAlert message={message} />}
    </>
  );
}
